var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { debounce } from '../../utils/debouncer.utils';
import SearchInput from '../SearchInput/SearchInput';
import SearchResultGrid from '../SearchResultGrid/SearchResultGrid';
import './SearchApplet.scss';
var SearchBarApplet = /** @class */ (function (_super) {
    __extends(SearchBarApplet, _super);
    function SearchBarApplet(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (value) {
            _this.setState({ value: value });
            _this.getValues(_this.state.value);
        };
        _this.getValues = debounce(function (searchQuery) {
            /*
              A little strange but by using /posts?search= endpoint it returns all post types (except tags)
              Documentation doesn't cover this and couldn't find anyone else reporting this 'problem'
              But decided this was the best way to go because it returns the results as WPPosts and not as Search Results
              (SearchResults aren't full posts, it is more limited, we can't get pictures)
            */
            var postPagePlanAPICall = fetch('/wp-json/wp/v2/posts?search=' + searchQuery + '&_embed&per_page=10'); // Need to include &_embed to use _embedded and per_page to increase the results
            var tagAPICall = fetch('/wp-json/wp/v2/tags?search=' + searchQuery);
            Promise.all([postPagePlanAPICall, tagAPICall])
                .then(function (response) { return Promise.all(response.map(function (r) { return r.json(); })); })
                .then(function (data) {
                _this.setState({ postPagePlanResultsArray: data[0], tagResulstArray: data[1] });
                // console.log(data);
                // console.log(this.state.postPagePlanResultsArray);
            });
        });
        _this.state = {
            value: "",
            postPagePlanResultsArray: [],
            tagResulstArray: [],
        };
        return _this;
    }
    SearchBarApplet.prototype.render = function () {
        var _a;
        var inputLenght = (_a = this.state.value) === null || _a === void 0 ? void 0 : _a.length;
        return (React.createElement("div", { className: "searchApplet" }, inputLenght > 0 ?
            React.createElement(React.Fragment, null,
                React.createElement(SearchInput, { className: "input-entered", inputPlaceholder: this.props.placeholder, inputValue: this.state.value, onInputChange: this.handleChange }),
                React.createElement(SearchResultGrid, { searchQuery: this.state.value, postPagePlanResultsArray: this.state.postPagePlanResultsArray, tagResultsArray: this.state.tagResulstArray }))
            :
                React.createElement(SearchInput, { className: "no-input", inputPlaceholder: this.props.placeholder, inputValue: this.state.value, onInputChange: this.handleChange })));
    };
    return SearchBarApplet;
}(React.Component));
export default SearchBarApplet;
